import type { CustodyLogEntry } from './types';

export const custodyLog: CustodyLogEntry[] = [
  { date: "2026-03-19 07:55", ko: "현장 압수 — 봉인 처리", mn: "Хэргийн газраас хураан авч лацдсан", by: "Б.Ганзориг" },
  { date: "2026-03-19 11:20", ko: "증거물 보관실 입고 (А-103)", mn: "Эд мөрийн баримтын өрөөнд хүлээлгэн өгсөн (А-103)", by: "Х.Батзул" },
  { date: "2026-03-21 09:00", ko: "감정 의뢰 출고 — 국과수", mn: "Шинжилгээнд илгээсэн — ШШҮХ", by: "Х.Батзул" },
];
